import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { cur } from '@/lib/currency';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload?.length) {
    return (
      <div className="bg-card border border-border rounded-xl px-3 py-2 shadow-lg text-xs">
        <p className="text-muted-foreground mb-1">{label}</p>
        <p className="font-bold text-primary">
          {(payload[0].value || 0).toLocaleString('ar-EG', { maximumFractionDigits: 0 })} {cur()}
        </p>
      </div>
    );
  }
  return null;
};

export default function SalesTrendChart({ data = [] }) {
  const formatted = data.map(d => ({
    ...d,
    label: d.date ? new Date(d.date).toLocaleDateString('ar-EG', { day: 'numeric', month: 'short' }) : d.date,
  }));

  // Show every 5th label to avoid crowding
  const tickDates = formatted.filter((_, i) => i % 5 === 0 || i === formatted.length - 1).map(d => d.label);

  return (
    <div className="bg-card border border-border rounded-2xl p-5 shadow-sm">
      <h3 className="font-bold text-foreground mb-4 text-sm">المبيعات — آخر 30 يوم</h3>
      <div className="h-40">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={formatted} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="salesGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(var(--primary))" stopOpacity={0.25} />
                <stop offset="95%" stopColor="hsl(var(--primary))" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }}
              axisLine={false} tickLine={false}
              ticks={tickDates}
            />
            <YAxis
              tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }}
              axisLine={false} tickLine={false}
              tickFormatter={v => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone" dataKey="value"
              stroke="hsl(var(--primary))" strokeWidth={2}
              fill="url(#salesGrad)" dot={false}
              activeDot={{ r: 4, fill: 'hsl(var(--primary))' }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}